import { Controller } from "@hotwired/stimulus"

// The username field (users/_username_gate): shows the address it makes as
// you type, and says whether it's free before you save.
export default class extends Controller {
  static targets = ["input", "preview", "status", "submit"]

  check() {
    const name = this.inputTarget.value.trim()
    this.previewTarget.textContent = name || "your_name"
    clearTimeout(this.timer)
    if (!name) return this.say("", "")
    if (!/^[a-zA-Z0-9_]+$/.test(name)) return this.say("Only letters, numbers and _", "is-bad")
    if (name.length < 3) return this.say("At least 3 characters", "is-bad")
    if (name.length > 30) return this.say("30 characters at most", "is-bad")
    this.say("Checking…", "")
    this.timer = setTimeout(() => this.lookUp(name), 250)
  }

  async lookUp(name) {
    try {
      const response = await fetch(`/users/check_username?username=${encodeURIComponent(name)}`)
      const { available } = await response.json()
      if (this.inputTarget.value.trim() !== name) return
      available ? this.say("It's free!", "is-ok") : this.say("Someone has that one", "is-bad")
    } catch {
      this.say("", "")
    }
  }

  say(text, state) {
    this.statusTarget.textContent = text
    this.statusTarget.className = `un-status ${state}`
    this.submitTarget.disabled = state === "is-bad"
  }
}
